module.exports = __webpack_public_path__ + "static/media/ic_edit.d8d219f1.svg";